<template>
  <div class="crm">
    <page-header
      title="Customer Engagement"
      breadcrumb="Dashboard > CRM > Customer Engagement "
    />
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-4 col-lg-4">
          <div class="card rounded py-4">
            <div class="flex justify-between">
              <div>
                <img
                  src="@/assets/images/icons/contact-count.svg"
                  alt="customer count icon"
                />
              </div>
              <div>
                <p class="text-2xl text-deepBlue font-semibold">
                  {{ count.totalContacts }}
                </p>
              </div>
            </div>
            <div class="pt-4">
              <p class="text-deepBlue">Number of Contacts</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 col-lg-4">
          <div class="card rounded py-4">
            <div class="flex justify-between">
              <div>
                <img
                  src="@/assets/images/icons/customer-count.svg"
                  alt="customer count icon"
                />
              </div>
              <div>
                <p class="text-2xl text-deepBlue font-semibold">
                  {{ count.totalCustomers }}
                </p>
              </div>
            </div>
            <div class="pt-4">
              <p class="text-deepBlue">Number of Customers</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 col-lg-4">
          <div class="card rounded py-4">
            <div class="flex justify-between">
              <div>
                <img
                  src="@/assets/images/icons/blacklisted-contacts.svg"
                  alt="customer count icon"
                />
              </div>
              <div>
                <p class="text-2xl text-deepBlue font-semibold">
                  {{ count.totalBlacklistedContacts }}
                </p>
              </div>
            </div>
            <div class="pt-4">
              <p class="text-deepBlue">Number of Blacklisted Contacts</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <customers-table @update="getContactsCount" />
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import CustomersTable from "./CustomersTable";

export default {
  components: {
    PageHeader,
    CustomersTable,
  },
  data() {
    return {
      count: {
        totalBlacklistedContacts: 0,
        totalContacts: 0,
        totalCustomers: 0,
      },
    };
  },
  mounted() {
    this.getContactsCount();
  },
  methods: {
    async getContactsCount() {
      try {
        const response = await this.$_getContactsCount();
        this.logResponse(response);
        this.count = response.data.customer;
        this;
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style></style>
